import { UpgradeGateway } from '../../../my-features/gateway/actions/gateway.actions';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { UserService } from '../../../services/user.service';
import * as fromStore from '../../../store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import * as fromFeature from '../../../my-features';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { updateInfoType } from '../../../shareModel';
import { MessageService } from 'primeng/api';
import { UtilsService } from '../../../services/utils.service';

@Component({
  standalone: false,
  selector: 'app-pro-upgrade',
  templateUrl: './pro-upgrade.component.html',
  styleUrls: ['./pro-upgrade.component.css']
})
export class ProUpgradeComponent implements OnInit, AfterViewInit {

  upgradable: boolean = false;
  stepIndex = 1;
  agreeUpgrade:boolean = false;
  progressTotal = 2;
  progressNumber: number = 0;
  upgradeAccountLoading:boolean = false;
  otp: string = '';
  DocDateParam = {
    ActivateDate: '',
    SettlementDate: ''
  };
  private componentDestroyed = new Subject;

  constructor(private userService: UserService, private store: Store<fromStore.State>, private ngxService: NgxUiLoaderService,
    private router: Router, private messageService: MessageService, private utils: UtilsService, private cdr: ChangeDetectorRef) {
    this.store.dispatch(new fromFeature.CheckProUpgrade());

    
    this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.otp = res.otp;
    });

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.type === updateInfoType.CheckProUpgrade && res.isLoaded) {
        if (res.isSaved) {
          this.upgradable = true;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.setProgress();
          }, 0);
        } else {
          this.router.navigate(['/dashboard']);
        }
      }

      if (res.type === updateInfoType.ActivateProUpgrade && res.isLoaded) {
        this.upgradeAccountLoading = false;
        if (res.isSaved) {
          const today = new Date();
          const todayString = this.formatDate(today);
          const currentDay = today.getDate();
          const nextMonthDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
          const daysInNextMonth = new Date(nextMonthDate.getFullYear(), nextMonthDate.getMonth() + 1, 0).getDate();
          const targetDay = Math.min(currentDay, daysInNextMonth);
          nextMonthDate.setDate(targetDay);
          const nextMonthString = this.formatDate(nextMonthDate);

          this.DocDateParam = {
            ...this.DocDateParam,
            ActivateDate: todayString,
            SettlementDate: nextMonthString,
          };
          this.stepIndex = 2;
          this.userService.UpgradPROSuccessLogout(this.otp).subscribe({
            next: () => {
            },
            error: err => {
              console.error('Logout failed', err);
            }
          });
          this.utils.removeToken();
          this.setProgress();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Upgrade Fail' });
        }
      }
    });
  }

  ngOnInit() {
    this.UI();
  }

  ngAfterViewInit() {
    if (this.upgradable) {
      this.cdr.detectChanges();
      setTimeout(() => {
        this.setProgress();
      }, 0);
    }
  }

  upgradeAccount() {
    this.upgradeAccountLoading = true;
    this.store.dispatch(new fromFeature.ActivateProUpgrade({}));
  }

  setProgress() {
    this.progressNumber = (this.stepIndex / this.progressTotal) * 100;
    const el = document.getElementsByClassName('circle-progress')[0] as HTMLElement;
    if (el) {
      el.style.setProperty('--value', this.progressNumber.toString());
    }
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-addDevice');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    body.classList.remove('body-help');
    body.classList.remove('body-login');
  }

  cancel() {
    this.router.navigate(['/dashboard']);
  }

  redirectLogin() {
    this.store.dispatch(new fromStore.LogoutSuccessAction());
    this.userService.SetRedirect = null;
    this.router.navigate(['/login']);
  }

  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  }
}
